export const nfiRoadData = [
  {
    id: 1,
    name: "포항 영일대 레드립스 커피",
    location: "경북 포항시 북구 해안로 55 포스타운",
    category: "카페",
    lat: "36.0535805555402",
    lng: "129.376913685955",
    naverLink: "https://naver.me/xVl3hVPp",
    note : "엔플라잉 포항 버스킹 때 다녀간 카페"
  },
  {
    id: 2,
    name: "영일대 해수욕장",
    location: "경북 포항시 북구 두호동 685-1",
    category: "장소",
    lat: "36.0572902321339",
    lng: "129.378068992389",
    naverLink: "https://naver.me/xpPB1I2T",
    note : "플라이하이 프로젝트 'WHERE TO FLY' 버스킹"
  },
  {
    id: 3,
    name: "달고떡볶이",
    location: "대구 달서구 야외음악당로39길 54 삼정그린빌상가 113동 107호",
    category: "맛집",
    lat: "35.8541511710543",
    lng: "128.554339587787",
    naverLink: "https://naver.me/5iz0ZL1g",
    note : "승협 학창시철 추억의 장소"
  },
  {
    id: 4,
    name: "짚신매운갈비찜 영등포점",
    location: "서울 영등포구 영중로4길 13 1층",
    category: "맛집",
    lat: "37.517589659504",
    lng: "126.907737266414",
    naverLink: "https://naver.me/FcagSSuh",
    note : "핵인싸 동맹 : 두얼간이 매운갈비찜"
  },
  {
    id: 5,
    name: "시골 김치 삼겹살",
    location: "서울 마포구 월드컵로 110 1층 시골김치삼겹살",
    category: "맛집",
    lat: "37.5583816474532",
    lng: "126.908345574502",
    naverLink: "https://naver.me/FcagSSuh",
    note : "엔플라잉 다녀간 삼겹살집"
  },
  {
    id: 6,
    name: "찬란한아구 강남본점",
    location: "서울 강남구 강남대로78길 12 2층 찬란한아구 강남본점",
    category: "맛집",
    lat: "37.4948475341971",
    lng: "127.030367339339",
    naverLink: "https://naver.me/GiHaTeI1",
    note : "승협이 다녀간 아구찜"
  },
  {
    id: 7,
    name: "카페비니 아치울점",
    location: "경기 구리시 아치울길 17",
    category: "카페",
    lat: "37.5741246696648",
    lng: "127.120072140662",
    naverLink: "https://naver.me/FT0kBORs",
    note : "승협이 친구랑 데이트"
  },
  {
    id: 8,
    name: "에이드티",
    location: "서울 성동구 상원12길 19 1층",
    category: "카페",
    lat: "37.550730034393",
    lng: "127.04981101799",
    naverLink: "https://naver.me/Gt9Mj9S2",
    note : "승협, 재현 단골 카페"
  },
  {
    id: 9,
    name: "데우스 카페 삼청점",
    location: "서울 종로구 삼청로 134",
    category: "카페",
    lat: "37.5872420747219",
    lng: "126.981815611418",
    naverLink: "https://naver.me/GvX5WYB0",
    note : "회승 & 재현 데이트"
  },
  {
    id: 10,
    name: "색장정미소",
    location: "전북 전주시 완산구 원색장길 2-15",
    category: "카페",
    lat: "35.7975593069138",
    lng: "127.187470102102",
    naverLink: "https://naver.me/5fnjYvy9",
    note : "엔플라잉 폭망 뮤비촬영지"
  },
  {
    id: 11,
    name: "컬러시그널 퍼스널컬러진단",
    location: "서울 강남구 역삼로20길 12 4층 컬러시그널",
    category: "장소",
    lat: "37.4944462999401",
    lng: "127.037624052477",
    naverLink: "https://naver.me/xsw8Aqx5",
    note : "두얼간이 퍼스널컬러 진단"

  },
  {
    id: 12,
    name: "달빛동맹",
    location: "서울 마포구 월드컵로36길 42",
    category: "맛집",
    lat: "37.5679872004367",
    lng: "126.905192606847",
    naverLink: "https://naver.me/xDsFvzSS",
    note : "승협 사진 속 장소"
  },
  {
    id: 13,
    name: "명동숯불닭갈비",
    location: "강원 춘천시 금강로62번길 10",
    category: "맛집",
    lat: "37.8794157097117",
    lng: "127.727700847008",
    naverLink: "https://naver.me/ForQlHTV",
    note : "엔플라잉 다녀간 닭갈비집"
  },
  {
    id: 14,
    name: "카페테드",
    location: "서울 마포구 성미산로32길 51",
    category: "카페",
    lat: "37.5627401592659",
    lng: "126.922610632303",
    naverLink: "https://naver.me/501ea8FZ",
    note : "승협 사진 속 카페"
  },
  {
    id: 15,
    name: "현대프리미엄아울렛 스페이스원",
    location: "경기 남양주시 다산순환로 50",
    category: "장소",
    lat: "37.616257926116",
    lng: "127.152429100255",
    naverLink: "https://naver.me/GWFrFXrq",
    note : "승협 사진 속 장소"
  },
  {
    id: 16,
    name: "을지로브이",
    location: "서울 중구 충무로 51 4층",
    category: "맛집",
    lat: "37.5657910103787",
    lng: "126.992497832713",
    naverLink: "https://naver.me/FCbBxWgr",
    note : "촬영장 굿밤 라이브" // https://x.com/NFlyingofficial/status/1189060920456044544
  },
  {
    id: 17,
    name: "반포종합운동장",
    location: "서울 서초구 반포2동 15-2",
    category: "장소",
    lat: "37.5005376398879",
    lng: "126.99426439255",
    naverLink: "https://naver.me/xmrPltJY",
    note : "승협 사진 속 장소"
  },
  {
    id: 18,
    name: "도우또 성수",
    location: "서울 성동구 서울숲4길 18-8 1층",
    category: "맛집",
    lat: "37.5470517097135",
    lng: "127.042673790996",
    naverLink: "https://naver.me/FTXODYQC",
    note : "승협 다녀간 덮밥집"
  },
  {
    id: 19,
    name: "술있는식탁 성수본점",
    location: "서울 성동구 왕십리로10길 18 반지층",
    category: "맛집",
    lat: "37.5465616785945",
    lng: "127.046435626195",
    naverLink: "https://naver.me/xyurciGt",
    note : "승협 FNC 선후배님과 다녀간 요리주점"
  },
  {
    id: 20,
    name: "합천일류돼지국밥",
    location: "부산 사상구 광장로 34 윌로펌프",
    category: "맛집",
    lat: "35.16225471541108",
    lng: "128.98008783271953",
    naverLink: "https://naver.me/FKKxxuzg",
    note : "부산 3대 돼지국밥 (승협 인생국밥)"
  },
  {
    id: 21,
    name: "남천녹차팥빙수",
    location: "부산 수영구 수영로394번길 28",
    category: "카페",
    lat: "35.1407428384391",
    lng: "129.10881041985093",
    naverLink: "https://naver.me/5HSEvH8r",
    note : "보컬즈가 먹고 간 옛날 스타일의 팥빙수"
  },
  {
    id: 22,
    name: "해운대명품호떡",
    location: "부산 해운대구 중동1로 38",
    category: "맛집",
    lat: "35.1622100514759",
    lng: "129.163126552708",
    naverLink: "https://naver.me/GqsTrB3v",
    note : "보컬즈가 다녀간 줄서서 먹는 호떡 맛집"
  },
  {
    id: 23,
    name: "송가네감자탕 본점",
    location: "서울 마포구 동교로 245 송가네감자탕",
    category: "맛집",
    lat: "37.5618364940379",
    lng: "126.924050688833",
    naverLink: "https://naver.me/535USHEc",
    note : "승협 연습생 때부터 가던 감자탕 집"
  },
  {
    id: 24,
    name: "싱싱횟집",
    location: "서울 성동구 성덕정길 90",
    category: "맛집",
    lat: "37.5376693827344",
    lng: "127.053399481711",
    naverLink: "https://naver.me/GXERlXej",
    note : "첫눈이 내린 날 엔플라잉이 다녀간 횟집"
  },
  {
    id: 25,
    name: "서브젝티브카페",
    location: "서울 성동구 광나루로 229",
    category: "카페",
    lat: "37.549882541627",
    lng: "127.055690503868",
    naverLink: "https://naver.me/Gxkovbpv",
    note : "승협 롱샴 광고 사진 속 카페"
  },
  {
    id: 26,
    name: "쿠마짱온센",
    location: "서울 성동구 연무장7길 5 2층",
    category: "맛집",
    lat: "37.5432380295407",
    lng: "127.054348975494",
    naverLink: "https://naver.me/x3qBfyKS",
    note : "동성이가 아버지와 식사하고 간 샤브샤브 집"
  },
];
